import { Action, Reducer } from "redux";
import { DeliveryTypeState, DeliveryTypeTypes, DeliveryTypeActionTypes } from "./deliveryTypeTypes";

export const INITIAL_STATE: DeliveryTypeState = {
	deliveryTypes: {
		data: null,
		errorMessages: null,
		isError: false,
		isLoading: false,
	},
};

const deliveryTypeReducer: Reducer<DeliveryTypeState> = (state: DeliveryTypeState = INITIAL_STATE, action: Action) => {
	const actionTypes = action as DeliveryTypeActionTypes;
	switch (actionTypes.type) {
		case DeliveryTypeTypes.GET_DELIVERYTYPES:
			return {
				...state,
				deliveryTypes: { ...state.deliveryTypes, isLoading: true },
			};
		case DeliveryTypeTypes.SAVE_DELIVERYTYPES:
			return {
				...state,
				deliveryTypes: {
					...state.deliveryTypes,
					isLoading: false,
					errorMessages: actionTypes.payload.errorMessages,
					isError: actionTypes.payload.isError,
					data: actionTypes.payload.data,
				},
			};
		case DeliveryTypeTypes.RESET_REDUCER_DELIVERYTYPES:
			return {
				...state,
				deliveryTypes: INITIAL_STATE.deliveryTypes,
			};
		default:
			return state;
	}
};

export default deliveryTypeReducer;
